import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AfCommonLibraryComponent } from './af-common-library.component';
import { NavRibbonComponent } from './nav-ribbon/nav-ribbon.component';
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from './material/material.module';
import { FooterComponent } from './footer/footer.component';


@NgModule({
  declarations: [AfCommonLibraryComponent, NavRibbonComponent, HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [AfCommonLibraryComponent, NavRibbonComponent, HeaderComponent, FooterComponent]
})
export class AfCommonLibraryModule { }
